// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__WLb8F","rotation":"styles_rotation__rP1Oq"};